import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import { Sidebar } from 'primereact/sidebar';
import { Tooltip } from 'primereact/tooltip';

import { Button } from "../../helpers";
import { Table } from "../../helpers"

import CopyToClipboard from '../../common/CopyToClipboard';

import { getDateString, getBuyerProductName, numberConversion, isMobile } from '../../utils';

import  Search  from './components/Search'

import { fetchOrderHistory,  updateSearchParams} from "../../services/redux/reducers/orderHistory/orderHistory";
import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { fetchMaterialsData } from '../../services/redux/reducers/Requirement/requirement';
import { fetchOrderTypesData, fetchLogisticPartners } from '../../services/redux/reducers/commonThunk';

import { getPMCompanyConfig } from '../../setup/pmCompanyConfig';


const OrderHistory = () => {
    const materialProductsData = useSelector(state => state.requirements.materialProductsData)
    const orderHistoryList = useSelector(state => state.orderHistory.orderHistoryList)
    const isLoading = useSelector(state => state.orderHistory.loading)
    const paginationParams = useSelector(state => state.orderHistory.paginationParams)
    const searchParams = useSelector(state => state.orderHistory.searchParams)
    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const [isSearchVisible, setIsSearchVisible] = useState(true)
    const [isTrackingDetailsVisible, setIsTrackingDetailsVisible] = useState(false)
    const [displayedTrackingDetails, setDisplayedTrackingDetails] = useState([])

    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchLogisticPartners())
        dispatch(fetchOrderTypesData())
        
        let branchIds = []
        let companyIds = []
        if(userDetails?.activeUserRoleDetails?.branchId){
            branchIds.push(userDetails?.activeUserRoleDetails?.branchId)
        } else {
            companyIds.push(userDetails?.activeUserRoleDetails?.companyId)
        }
        dispatch(updateSearchParams({...searchParams, branchIds, companyIds}))
    }, [userDetails])

    useEffect(() => {
        if(orderHistoryList.length > 0){
            let buyerReqItemIds = []
            orderHistoryList?.map(eachInvoice=>{
                eachInvoice?.buyerInvoiceItems?.map(eachInvoiceItem => {
                    if(eachInvoiceItem?.buyerReqItemId && !buyerReqItemIds.includes(eachInvoiceItem?.buyerReqItemId)){
                        buyerReqItemIds.push(eachInvoiceItem?.buyerReqItemId)
                    }
                })
            })
            let materialIdParams = {
                buyerReqItemsIds: buyerReqItemIds
            }
            
            dispatch(fetchMaterialsData(materialIdParams))
        }
    },[orderHistoryList])

    const getBuyerPONumbersBody = (row) => {
        if (row?.buyerPONumbers){
            return (
                <div className="text-center">
                    <div className='flex flex-row justify-content-center' >
                        <div>{row?.buyerPONumbers.join(", ")}</div>
                    </div>
                </div>
            )
        }
    }

    const getInvoiceDocNoBody = (row) => {
        if (row?.docNo){
            let dateString = row["createdAt"] ? getDateString(row["createdAt"]) : "-"
            return (
                <div className="text-center">
                    <div className='flex flex-row justify-content-center' >
                        <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/buyerInvoice/${row["buyerInvoiceId"]}`, '_blank')}>{row["docNo"]}</p>
                        <CopyToClipboard text={row.docNo} />
                    </div>
                    <div className="">{dateString}</div>
                </div>
            )
        }
    }

    const getProductBody = (row) => {
        const buyerDocNo = row?.docNo
        let productNamesListWithDuplicates = []
        let productNamesList = []

        if(row?.buyerInvoiceItems?.length > 0){
            row?.buyerInvoiceItems?.map(eachInvoiceItem => {
                let relatedMaterialItemData = materialProductsData?.find(eachMaterial => eachMaterial.buyerReqItemId === eachInvoiceItem.buyerReqItemId)
                if(relatedMaterialItemData){
                    let productName = getBuyerProductName(relatedMaterialItemData?.companyProdName, relatedMaterialItemData.productName)
                    if(productNamesList.includes(productName)){
                        productNamesListWithDuplicates.push(productName)
                    }else{
                        productNamesList.push(productName)
                    }
                }
            })
        }

        if(productNamesList.length > 0 && productNamesListWithDuplicates.length > 0){
            const totalProductNamesStr = `${productNamesList.join(", ")}, ${productNamesListWithDuplicates.join(", ")}`
            const displayProductNameStr = `${productNamesList.slice(0,6).join(", ")} & ${productNamesList.slice(6).length+productNamesListWithDuplicates.length} more items`

            return (
                <>
                    <Tooltip target={`.custom-tool-tip-${buyerDocNo}`} position="top" autoHide className='post-req-tooltip' >
                        <p className='m-0'>{totalProductNamesStr}</p>
                    </Tooltip>
                    <p className={`custom-tool-tip-${buyerDocNo}`} style={{ margin: "0px"}} >
                    {displayProductNameStr}
                    </p>
                </>
            )
        }
        return (productNamesList.length > 6 ? `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length} more items` : productNamesList.join(", "))
    }

    const getUserName = (row) => {
        if (row?.user) {
            let userName = row?.user?.firstName
            if (row?.user?.lastName) {
                userName = userName + " " + row?.user?.lastName
            }
            return <div> {userName} </div>
        }
        else {
            return <div> - </div>
        }
    }

    const getAmountPayble = (row) =>{
        return(
            numberConversion(parseFloat(row.totalInvAmount), numberLocale)
        )
    }

    const handleTrackingDetailsView = (row) => {
        const trackingDetails = []
        row.invoiceDispatchMap.map(eachDispatchNoteMap => {
            if(eachDispatchNoteMap.dispatchNote?.trackingNumber){
                trackingDetails.push(eachDispatchNoteMap.dispatchNote)
            }
        })

        setIsTrackingDetailsVisible(true)
        setDisplayedTrackingDetails(trackingDetails)
    }

    const getTrackingInformation = (row) => {
        return(
            <div>
                {
                    row.invoiceDispatchMap?.[0]?.dispatchNote?.trackingNumber ?
                    (
                        <a style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => handleTrackingDetailsView(row)}> View </a>
                    ): "-"
                }
            </div>
        )
    }

    const tableColumns = [
        {
            header: 'Invoice No',
            field: '',
            body: getInvoiceDocNoBody
        },
        {
            header: 'BuyerPO Nos',
            field: '',
            body: getBuyerPONumbersBody

        },
        {
            header: 'Product Name',
            field: '',
            body : getProductBody

        },
        {
            header: 'Amount Payble',
            field: 'totalInvAmount',
            body: getAmountPayble,
        },
        {
            header : 'User Name' ,
            field : '',
            body: getUserName,
        },
        {
            header: 'Tracking',
            field: 'trackingInformation',
            body: getTrackingInformation
        }
    ]

    const handlePageChange = async (e) => {
        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        dispatch(fetchOrderHistory(paginatorParams))
    }

    return (

        <div className="order-history-layout flex flex-column">

            <Toast ref={Toast} />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">INVOICES</h4> 
                <div className="flex gap-2 justify-content-end">
                    <div className="flex justify-content-end mb-2">
                        <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={() => {setIsSearchVisible(!isSearchVisible)}} />
                    </div>
                </div>
            </div>

            <div className='flex flex-row'>
                <div className="pi-wise-invoice-booking-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%",  maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1">
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                tableColumns={tableColumns}
                                data={orderHistoryList}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight={"550px"}
                                paginator
                                totalRecords={paginationParams.totalRecords}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>
                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Search />
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => setIsSearchVisible(false)}>
                            <Search />
                        </Sidebar>
                    </div>
                }
            </div>

            <Dialog header="Tracking Details" visible={isTrackingDetailsVisible} style={{ width: '45vw', height: '30vh' }} onHide={() => {setIsTrackingDetailsVisible(false); setDisplayedTrackingDetails([])}}>
                <div className="ml-2 mr-2 mt-0 pt-0">
                    <div>
                        <div className="flex justify-content-between">
                            <div className="flex flex-wrap py-2 w-full">
                                <div className="flex justify-content-between flex-grow-1 font-bold header-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize:"14px" }}>
                                    <div className="mt-1" style={{ width: '33%' }}>Tracking Number</div>
                                    <div className="mt-1" style={{ width: '33%' }}>Tracking Order Link</div>
                                    <div className="mt-1" style={{ width: '34%' }}>Document</div>
                                </div>
                                {
                                    displayedTrackingDetails?.map(eachTrackingDetails => {
                                        return (
                                            <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                <div className="py-1 align-self-center" style={{ width: '33%' }}>{eachTrackingDetails?.trackingNumber}</div>
                                                <div className="py-1 align-self-center" style={{ width: '33%' }}>
                                                    { eachTrackingDetails?.trackingOrderLink ? <a href={ eachTrackingDetails.trackingOrderLink} target="_blank" >View</a> : "" }
                                                </div>
                                                <div className="py-1 align-self-center" style={{ width: '34%' }}>
                                                    { eachTrackingDetails?.trackingDocPath ? <a href={ eachTrackingDetails.trackingDocPath} target="_blank" >View</a> : "" }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>

    )

}

export default OrderHistory